var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileappIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_1165",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 492.5V7.5H7.5V492.5H492.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_1165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76562 151.686H454.608",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3154 110.129C104.104 110.129 114.54 99.7266 114.54 86.9443C114.54 74.1621 104.104 63.7598 91.3154 63.7598C78.5547 63.7598 68.1182 74.1621 68.1182 86.9443C68.1182 99.7266 78.5547 110.129 91.3154 110.129Z",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.92 63.7598H380.283C393.044 63.7598 403.48 74.1904 403.48 86.9443C403.48 99.6992 393.044 110.129 380.283 110.129H292.92C280.159 110.129 269.723 99.6992 269.723 86.9443C269.723 74.1904 280.159 63.7598 292.92 63.7598Z",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.962 110.129C189.751 110.129 200.187 99.7266 200.187 86.9443C200.187 74.1621 189.751 63.7598 176.962 63.7598C164.201 63.7598 153.765 74.1621 153.765 86.9443C153.765 99.7266 164.201 110.129 176.962 110.129Z",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.609 226.801L139.065 308.585",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.62 301.198L231.273 270.155C232.491 268.8 232.491 266.587 231.273 265.231L203.62 234.188",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0566 301.198L66.4033 270.155C65.1846 268.8 65.1846 266.587 66.4033 265.231L94.0566 234.188",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.038 269.961C405.723 272.341 415.716 276.546 424.713 282.189L432.713 274.222C437.446 269.463 445.225 269.463 449.986 274.222L462.581 286.811C467.342 291.569 467.342 299.344 462.581 304.075L454.608 312.07C460.303 321.104 464.422 331.04 466.789 341.453H477.999C484.727 341.453 490.234 346.959 490.234 353.654V371.5C490.234 378.194 484.727 383.7 477.999 383.7H466.733C464.36 394.051 460.261 403.928 454.608 412.917L462.581 420.885C467.342 425.644 467.342 433.418 462.581 438.149L449.986 450.766C445.225 455.524 437.446 455.524 432.713 450.766L424.713 442.797C415.688 448.473 405.767 452.58 395.37 454.943V466.286C395.37 473.01 389.861 478.516 383.163 478.516H365.309C358.608 478.516 353.101 473.01 353.101 466.286V454.916C342.581 452.536 332.699 448.358 323.812 442.797L315.841 450.766C311.079 455.524 303.302 455.524 298.567 450.766L285.945 438.149C281.211 433.418 281.211 425.644 285.945 420.885L293.944 412.917C288.272 403.935 284.163 394.056 281.793 383.7H270.471C263.745 383.7 258.263 378.194 258.263 371.5V353.654C258.263 346.959 263.745 341.453 270.471 341.453H281.766C284.108 331.159 288.159 321.33 293.751 312.375L285.724 304.324C280.963 299.593 280.963 291.818 285.724 287.06L298.318 274.471C303.08 269.712 310.858 269.712 315.592 274.471L323.536 282.384C332.525 276.69 342.407 272.546 352.769 270.127V258.867C352.769 252.144 358.249 246.638 364.976 246.638H382.803C389.529 246.638 395.038 252.144 395.038 258.867V269.961Z",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.248 312.265C402.04 312.265 424.573 334.786 424.573 362.591C424.573 390.369 402.04 412.89 374.248 412.89C346.429 412.89 323.895 390.369 323.895 362.591C323.895 334.786 346.429 312.265 374.248 312.265Z",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.938 383.701H46.1387C26.1543 383.701 9.76562 364.142 9.76562 340.265V64.9219C9.76562 41.0186 26.125 21.4854 46.1387 21.4854H418.235C438.249 21.4854 454.608 41.0459 454.608 64.9219V278.844M270.471 383.701H191.219",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.676 383.701H147.869",
    stroke: "white",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileappIcon);
export default __webpack_public_path__ + "static/media/mobileapp-icon.0a66f39182beef3f9ff86415350a3c68.svg";
export { ForwardRef as ReactComponent };